module.exports = __webpack_public_path__ + "img/ico_2.2c313cf4.svg";